/**
 * Dependencies.
 */
import {
  BaseModel,
  ClassConstructorType,
  MODEL_METADATA,
  RESTService
} from '@prz-dp/services';

/**
 * Export `BaseService`.
 */
export class BaseService<T extends BaseModel> extends RESTService<T, number> {
  /**
   * Property `modelEndpoint`;
   */
  private modelEndpoint: string = null;

  /**
   * Method `getModelEndpoint`.
   */
  get getModelEndpoint() {
    return this.modelEndpoint;
  }

  /**
   * Constructor.
   */
  constructor(
    ResourceClass: ClassConstructorType<T>,
    module: string,
    baseApiUrl: string
  ) {
    super(ResourceClass, module, baseApiUrl);

    this.modelEndpoint = `${baseApiUrl}/${Reflect.getMetadata(
      MODEL_METADATA.ENDPOINTS,
      ResourceClass
    )}`;
  }
}
